﻿import { Component } from "@basic-orange/component";

var timer;
export default class ComponentA extends Component {
    constructor(elm, componentId) {
        super(elm, componentId); 

        //script for mobile layouts
        $('.mainmenu.mainmenu-level0 > li > a').click(this.onMainmenuRootLevelClick.bind(this));
        if(!!window.MSInputMethodContext && !!document.documentMode) {
            
            $('.mainmenu.mainmenu-level0 > li').on('mouseenter',function(){
                clearTimeout(timer);
                $(this).addClass('hover');
            }).on('mouseleave',function() {
                var $this = $(this);
                timer = setTimeout(function(){
                    $this.removeClass('hover');
                },500);
            });
        }

    }

    onMainmenuRootLevelClick(event) {
        if (Foundation.MediaQuery.current === "small") {
            event.preventDefault();
        }
    }
}